<template>
  <ppt-modal modalLg="true">
    <header slot="header">
      <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
      <button type="button" class="btn btn-primary" v-on:click="narrowRange()">Narrow range</button>
      <button class="btn btn-default clear-checks" v-on:click="clearAllChecks()">
        <span class="full-text">Clear all checks</span>
        <span class="partial-text">Clear</span>
      </button>
      <button class="btn btn-default set-checks-to-default" v-on:click="setChecksToDefault()">
        <span class="full-text">Set checkboxes to default</span>
        <span class="partial-text">Default</span>
      </button>
    </header>
    <section slot="body">
      <five-card-hands-section
        v-bind:playerState="playerState"
        v-bind:hideHeader="true"
        v-on:setCheckedValueOfFiveCardHand="setCheckedValueOfFiveCardHand($event)"
        v-on:toggleCollapsedValueOfFiveCardHandParent="toggleCollapsedValueOfFiveCardHandParent($event)"
      ></five-card-hands-section>
    </section>
  </ppt-modal>
</template>

<script>
import PlayerState from '@/services/player/PlayerState';
import PPTModal from '@/components/utilities/modal';
import FiveCardHandsSection from '@/components/five-card-hands-section/five-card-hands-section';

export default {
  name: 'narrow-range-modal',
  components: {
    'ppt-modal': PPTModal,
    'five-card-hands-section': FiveCardHandsSection,
  },
  data: function () {
    let playerState = new PlayerState();

    playerState.fiveCardHands.forEachLeaf(function (leaf) {
      leaf._probability = 0.000001;
    });

    return {
      playerState: playerState,
    };
  },
  created: function () {
    this.setChecksToDefault();
    this.setCollapsedValuesToDefault();
  },
  methods: {
    setCheckedValueOfFiveCardHand: function (payload) {
      this.playerState.fiveCardHands.find(payload.fiveCardHandId).checked = payload.newCheckedValue;
    },
    toggleCollapsedValueOfFiveCardHandParent: function (fiveCardHandParent) {
      fiveCardHandParent.collapsed = !fiveCardHandParent.collapsed;
    },
    clearAllChecks: function () {
      this.playerState.fiveCardHands.forEachLeaf(function (leaf) {
        leaf.checked = false;
      });
    },
    narrowRange: function () {
      this.$emit('narrowRange', this.playerState.fiveCardHands.checkedHands);
      $(this.$el).modal('hide');
    },
    setChecksToDefault: function () {
      let settingsDefaultChecks = this.$store.state.account.user.settings.hitCalculator.defaultChecks;
      let defaultCheckedResults = settingsDefaultChecks.afterFlop.default.straightforward;

      this.playerState.fiveCardHands.madeHands.forEachLeaf(function (madeHand) {
        if (defaultCheckedResults.madeHands.includes(madeHand.id)) {
          madeHand.checked = true;
        } else {
          madeHand.checked = false;
        }
      });
      this.playerState.fiveCardHands.draws.forEachLeaf(function (draw) {
        if (defaultCheckedResults.draws.includes(draw.id)) {
          draw.checked = true;
        } else {
          draw.checked = false;
        }
      });
      this.playerState.fiveCardHands.combos.forEachLeaf(function (combo) {
        if (defaultCheckedResults.combos.includes(combo.id)) {
          combo.checked = true;
        } else {
          combo.checked = false;
        }
      });
    },
    setCollapsedValuesToDefault: function () {
      this.playerState.fiveCardHands.setCollapsedValuesToDefaults(this.$store.state.account.user.settings);
    },
  },
};
</script>

<style lang="scss" scoped>
  header {
    .set-checks-to-default, .clear-checks {
      float: right;
      margin-right: 10px;

      .partial-text {
        display: none;
      }
    }

    button.close {
      position: relative;
      top: 5px;
    }
  }

  .panel-default {
    border: none;
    position: relative;
    top: -15px;
  }

  @media (max-width: 450px) {
    header .set-checks-to-default, header .clear-checks {
      .full-text {
        display: none;
      }

      .partial-text {
        display: inline;
      }
    }
  }

  @media (max-width: 425px) {
    header button.close {
      padding-left: 5px;
      padding-right: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/equity-calculator/narrow-range-modal.vue